import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_picker_popup = _resolveComponent("picker-popup")!

  return (_openBlock(), _createBlock(_component_picker_popup, {
    columnCount: 3,
    leftDisabled: _ctx.leftDisabled,
    rightDisabled: _ctx.rightDisabled,
    items: _ctx.years,
    onLeft: _ctx.previousPage,
    onRight: _ctx.nextPage,
    onElementClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select', $event)))
  }, {
    heading: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.heading), 1)
    ]),
    _: 1
  }, 8, ["leftDisabled", "rightDisabled", "items", "onLeft", "onRight"]))
}